import type { EnterpriseTradeOrder } from '~/services/ProServer/types'

const ORDER_KEY_PREFIX = 'enterprise-checkout-order:'
const ORDER_MAX_AGE = 24 * 60 * 60 * 1000

/** 按支付会话保存订单，防止多个购买标签页把最后一单误认为本次回跳订单。 */
export function rememberEnterpriseCheckout(sessionId: string, orderNo: string) {
  if (!sessionId || !orderNo || typeof window === 'undefined') return
  try {
    window.localStorage.setItem(ORDER_KEY_PREFIX + sessionId, JSON.stringify({ orderNo, createdAt: Date.now() }))
  } catch { /* 浏览器禁用存储时，仍允许支付；结果页只展示支付状态。 */ }
}

export function readEnterpriseCheckout(sessionId?: string): string | undefined {
  if (!sessionId || typeof window === 'undefined') return undefined
  try {
    const key = ORDER_KEY_PREFIX + sessionId
    const saved = JSON.parse(window.localStorage.getItem(key) || 'null')
    if (typeof saved?.orderNo === 'string' && Number.isFinite(saved.createdAt)
      && Date.now() - saved.createdAt >= 0 && Date.now() - saved.createdAt < ORDER_MAX_AGE) return saved.orderNo
    window.localStorage.removeItem(key)
  } catch { /* 损坏或旧缓存不能影响登录、支付状态查询。 */ }
  return undefined
}

export function getEnterpriseOrderState(order: EnterpriseTradeOrder): 'pending' | 'paid' | 'manual' | 'failed' {
  if (Number(order.status) === 0) return 'pending'
  if (Number(order.status) !== 1) return 'failed'
  let remark: Record<string, unknown> = {}
  try {
    const parsed = typeof order.remark === 'string' ? JSON.parse(order.remark) : order.remark
    if (parsed && typeof parsed === 'object') remark = parsed
  } catch { /* 历史订单备注不是JSON时不误报支付失败。 */ }
  return remark.businessPlanFulfillment === 'MANUAL_PENDING' ? 'manual' : 'paid'
}

export const ENTERPRISE_ORDER_MANUAL_MESSAGE = '支付已完成，但套餐状态已变化，需人工处理。请勿重复付款，请联系客服并提供订单号。'
